export class SelectOptionModel {
  name: string; // Display name
  value: string; // Id
  disabled?: boolean;
  constructor(name: string, value: string, disabled?: boolean) {
    this.name = name;
    this.value = value;
    this.disabled = disabled;
  }
}

export class SelectDisableOptionModel extends SelectOptionModel {
  override disabled: boolean = false;
  constructor(name: string, value: string, disabled: boolean = false) {
    super(name, value);
    this.disabled = disabled;
  }
}
